<template>
    <div class="question-item">
        <div class="question-item-title"><span v-if="mustShowCodes">[{{ questionData.code }}]</span>
            <span v-if="questionData.decisionItem && (questionData.decisionItem !== null && questionData.decisionItem.icon === null)"
                  v-bind:style="{'color': questionData.decisionItem.color }">*</span>
            <span class="icon-decision-item"
                  v-if="questionData.decisionItem && questionData.decisionItem.icon !== null"
                  v-html="iconValue">
            </span>

            <span class="question-title" v-if="questionData.decisionItem && (questionData.decisionItem !== null && questionData.decisionItem.color !== null)"
                  v-bind:style="{'color': questionData.decisionItem.color }">{{ questionData.name }}</span>
            <span class="question-title" v-else>{{ questionData.name }}</span>

            <help-icon  v-if="questionData.description"
                        :color="getQuestionColor(questionData)"
                        @onClickHelpIcon="openQuestionDescriptionPopup(questionData)"
                        class="float-right question-description-icon"
            ></help-icon>
            <question-description-popup
                v-if="questionForDescriptionPopup"
                :questionData="questionForDescriptionPopup"
                @onCloseQuestionDescPopup="hideQuestionDescriptionPopup()"
            ></question-description-popup>

        </div>

        <v-dialog v-model="dialog" scrollable max-width="300px" class="dialog-symptoms">
            <template slot="activator" v-if="answerOptionsMob">
                <div v-for="answertext in answerOptionsMob">

                    <div  v-if="answertext.code === questionData.providedAnswer">

                        <v-text-field color="primary"
                                       :value="answertext.text"
                                       :placeholder="text('api.assessment.select.answer')"
                                       box
                                       append-icon="keyboard_arrow_down">
                        </v-text-field>
                    </div>

                </div>
            </template>

            <v-card>
                <v-card-title class="symptom-question-title-pf">
                    <h3 class="question-name">{{ questionData.name }}</h3>
                    <p class="question-text">{{ questionData.text }}</p></v-card-title>

                <v-card-text class="pf-dialog-symptoms">

                    <v-radio-group v-model="questionData.providedAnswer" class="answers-group-pf">
                                <v-list-tile
                                    v-for="answer in answerOptionsMob"
                                    :key="answer.code"
                                    @click="handleChangeAnswer(answer.code)"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title><span class="symptom-name">{{answer.text}}</span></v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action  >
                                        <v-radio :value="answer.code" ></v-radio>
                                    </v-list-tile-action>
                                </v-list-tile>

                    </v-radio-group>

                </v-card-text>

                <v-card-actions class="pf-dialog-actions">
                    <v-btn  flat @click="dialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import HelpIcon from "../svg/shared/helpIcon";
    import QuestionDescriptionPopup from "./QuestionDescriptionPopup";

    export default {
        components: {
            HelpIcon,
            QuestionDescriptionPopup
        },
        name: 'SymptomQuestionItem',
        data () {
            return {
                dialogm1: this.questionData.providedAnswer,
                dialog: false,
                label: '',
                answerText: '',
                iconValue: '',
                colors: '',
                questionForDescriptionPopup: null
            }
        },
        props: {
            questionData: {
                type: Object,
                required: true
            },
            mustShowFullQuestion: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters({
                mustShowCodes: 'UserStore/getDebugMustShowCodes',
                showAnswerName: ''
            }),
            answerOptionsMob () {
                let answerListMob = this.questionData.answers;

                if(answerListMob[0].code !== null) {
                    answerListMob.unshift({
                        code: null,
                        id: null,
                        text: this.text("api.assessment.select.answer")

                    });
                }


                if(this.questionData.decisionItem) {
                    this.colors = this.questionData.decisionItem.color;
                    if(this.questionData.decisionItem.icon) {
                        this.iconValue = this.questionData.decisionItem.icon.replace(/COLOR_PLACEHOLDER/gi, this.colors);
                    }
                }

                return answerListMob;
            }
        },

        methods: {
            handleChangeAnswer (selectedAnswerCode) {
                this.$emit('onProvideQuestionAnswer', {
                    newProvidedAnswerCode: selectedAnswerCode,
                    questionCode: this.questionData.code
                });

                this.dialog = false;
            },

            openQuestionDescriptionPopup(question) {
                this.questionForDescriptionPopup = question;
            },
            hideQuestionDescriptionPopup() {
                this.questionForDescriptionPopup = null;
            },
            getQuestionColor(questionData) {
                if (questionData.decisionItem && (questionData.decisionItem !== null && questionData.decisionItem.color !== null)) {
                    return questionData.decisionItem.color;
                }
                else {
                    return '#515b60';
                }
            }
        },

        created() {

            if(this.questionData.decisionItem) {
                this.colors = this.questionData.decisionItem.color;
                if(this.questionData.decisionItem.icon) {
                    this.iconValue = this.questionData.decisionItem.icon.replace(/COLOR_PLACEHOLDER/gi, this.colors);
                }
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .item-mobile, .answer-radio {
        width: 100%;
        padding: 7px 5px;
        border-bottom: 1px solid $color-gray-lightest;
    }

    .item-mobile {

        &:hover {
            cursor: pointer;
        }

        .icon {
            float: right;
            position: relative;
            top: 10px;
        }

        .question-text {
            font-size: $font-size-default;
        }
    }

    .question-item span.dialog-name {
        color: $color-headings-text;
        font-weight: $font-weight-bold;
    }

    .dialog--scrollable .card {
        padding: 0;
    }

    .question-description-icon {
        cursor: pointer;
    }

    .question-name{
        font-weight: $font-weight-bold;
    }

    .card > :last-child:not(.btn) {
        border-top: none;
    }

    .card > .card__text {
        padding: 0;

       .input-group__input .input-group {
            padding: 7px 12px;
            border-bottom: 1px solid $color-gray-lightest;

           label {
               left: 40px !important;
           }
        }
    }

    .pf-dialog-actions {
        position: relative;
        min-height: 50px;

        .btn {
            position: absolute;
            right: 0;
        }
    }
</style>




// WEBPACK FOOTER //
// src/common/components/shared/SymptomQuestionItemPf.vue